export const dummyPosts = [
	{
		"postTitle": { "titleText": "Top 10 Hidden Gems to Visit in Europe" },
		"postId": { "id": 201 },
		"postDate": { "date": "03/04/2025" },
		"postAuthor": { "authorName": "Haris" },
		"commentsCount": { "count": 87 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/LDxT0SD1/post-thumb-1.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Discover breathtaking but lesser-known destinations across Europe that offer unique experiences without the crowds." }
	},
	{
		"postTitle": { "titleText": "A Backpacker’s Guide to Southeast Asia" },
		"postId": { "id": 202 },
		"postDate": { "date": "18/02/2025" },
		"postAuthor": { "authorName": "Amina" },
		"commentsCount": { "count": 104 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/XZbKK1Z6/post-thumb-6.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Explore budget-friendly tips and must-see destinations for traveling through Thailand, Vietnam, Cambodia, and beyond." }
	},
	{
		"postTitle": { "titleText": "The Ultimate Road Trip Across the USA" },
		"postId": { "id": 203 },
		"postDate": { "date": "25/01/2025" },
		"postAuthor": { "authorName": "Zara" },
		"commentsCount": { "count": 76 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/KjFQ62ZC/post-thumb-2.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Take a journey through America's most iconic highways and national parks with this cross-country itinerary." }
	},
	{
		"postTitle": { "titleText": "Exploring Morocco: A Cultural Adventure" },
		"postId": { "id": 204 },
		"postDate": { "date": "07/03/2025" },
		"postAuthor": { "authorName": "Yusuf" },
		"commentsCount": { "count": 65 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/1tpXJpb8/post-thumb-3.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "From bustling souks to the majestic Sahara Desert, Morocco offers an unforgettable travel experience." }
	},
	{
		"postTitle": { "titleText": "Island Hopping in the Philippines" },
		"postId": { "id": 205 },
		"postDate": { "date": "28/02/2025" },
		"postAuthor": { "authorName": "Sana" },
		"commentsCount": { "count": 91 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/qYBxwSRd/post-thumb-4.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Hop across turquoise waters and explore the tropical paradise of over 7,000 islands in the Philippines." }
	},
	{
		"postTitle": { "titleText": "A Winter Escape to the Swiss Alps" },
		"postId": { "id": 206 },
		"postDate": { "date": "14/01/2025" },
		"postAuthor": { "authorName": "Omar" },
		"commentsCount": { "count": 112 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/nNcqKzhy/post-thumb-5.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Ski resorts, cozy chalets, and snow-covered peaks — explore why Switzerland is the ultimate winter destination." }
	},
	{
		"postTitle": { "titleText": "Safari Adventures in Kenya" },
		"postId": { "id": 207 },
		"postDate": { "date": "19/03/2025" },
		"postAuthor": { "authorName": "Fatima" },
		"commentsCount": { "count": 130 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/7dQJMQt0/post-thumb-7.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Witness the Big Five and breathtaking savannah landscapes in this guide to Kenya's best safari experiences." }
	},
	{
		"postTitle": { "titleText": "A Culinary Journey Through Italy" },
		"postId": { "id": 208 },
		"postDate": { "date": "10/02/2025" },
		"postAuthor": { "authorName": "Nadia" },
		"commentsCount": { "count": 88 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/RTmJfQWC/post-thumb-9.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "From pasta in Rome to gelato in Florence — indulge in Italy’s rich culinary delights city by city." }
	},
	{
		"postTitle": { "titleText": "Weekend Getaways Near Dubai" },
		"postId": { "id": 209 },
		"postDate": { "date": "04/04/2025" },
		"postAuthor": { "authorName": "Ahmed" },
		"commentsCount": { "count": 73 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/dsGMxFGq/post-thumb-8.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Escape the city hustle with these top short-trip destinations just hours from Dubai." }
	},
	{
		"postTitle": { "titleText": "Japan in Spring: The Beauty of Cherry Blossoms" },
		"postId": { "id": 210 },
		"postDate": { "date": "30/03/2025" },
		"postAuthor": { "authorName": "Layla" },
		"commentsCount": { "count": 147 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/6ccT3PxS/post-thumb-10.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Plan your spring trip to Japan to catch the magical sakura season with our tips on the best viewing spots." }
	}
]
